module.exports = __webpack_public_path__ + "img/INVITATO_SX.67cf7694.png";